export default{
  setBanners(state,payload) {
    state.banners = payload;
  },
};
